import {svgIconWrapper} from '../svg-icon-wrapper';

import QuotientRegular from './quotient-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <QuotientRegular {...props} />;
}

SvgComponent.iconName = 'quotientRegular';

export const QuotientRegularIcon = svgIconWrapper(SvgComponent);
